import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { parseIso8601String } from "@interface48/formatting";
import FormControl from "@material-ui/core/FormControl";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import React from "react";
import { Label } from "../../templates";

const styles = (theme: Theme) =>
  createStyles({
    display: {
      color: theme.palette.text.primary,
      marginTop: theme.spacing(2),
      padding: "7px 0 9px",
    },
    time: {
      marginRight: "1rem",
      "& svg": {
        cursor: "help",
      },
    },
    user: {
      display: "inline-block",
      whiteSpace: "nowrap",
      "& svg": {
        cursor: "help",
      },
    },
  });

export interface AuditDetailsFieldProps extends WithStyles<typeof styles> {
  id?: string;
  at?: string | null;
  userName?: string | null;
  personName?: string | null;
  label?: string;
  margin?: "dense" | "none" | "normal";
}

export const AuditDetailsFieldComponent = (props: AuditDetailsFieldProps) => {
  const { id, label, margin, at, userName, personName, classes } = props;

  const auditDateTime = at && parseIso8601String(at);
  const by = personName ? (
    <span title={`On Account ${userName}`} style={{ cursor: "help" }}>
      {personName}
    </span>
  ) : (
    <span>{userName}</span>
  );

  return (
    <FormControl fullWidth={true} margin={margin || "normal"}>
      {label && <Label fieldId={id} label={label} labelOnly={true} />}
      <div className={classes.display}>
        {auditDateTime ? (
          <>
            <span className={classes.time}>
              <FontAwesomeIcon icon={["fas", "clock"]} title="Time" />
              &nbsp;&nbsp;
              <span>{`${auditDateTime.date} ${auditDateTime.time}`}</span>
            </span>
            <span className={classes.user}>
              <FontAwesomeIcon icon={["fas", "user"]} title="User" />
              &nbsp;&nbsp;
              {by}
            </span>
          </>
        ) : (
          "(Never)"
        )}
      </div>
    </FormControl>
  );
};

export const AuditDetailsField = withStyles(styles)(AuditDetailsFieldComponent);
